// This utility looks at the current url and chops off the last category segemnt
// aswell as anything after it. The utility will return the remainder of the url

// For example /shop/men/clothing would return /shop/men
// 2nd example /shop/men/clothing/f/color-orange would return /shop/men

const trimUrlByOneCategorySegment = (url: string) => {
    const splitArray = url.split("/")
    const fIndex = splitArray.indexOf("f")

    if (fIndex !== -1) {
        splitArray.splice(fIndex, splitArray.length - fIndex)
    }

    splitArray.pop()

    const manipulatedUrl = splitArray.join("/")
    return manipulatedUrl
}

export default trimUrlByOneCategorySegment
